module.exports = __webpack_public_path__ + "img/integrations-threedcart.5f50204d.png";